export const GET_COMPANIES_LIST_REQUEST = "GET_COMPANIES_LIST_REQUEST";
export const GET_COMPANIES_LIST_SUCCESS = "GET_COMPANIES_LIST_SUCCESS";
export const GET_COMPANIES_LIST_FAILURE = "GET_COMPANIES_LIST_FAILURE";

export const SET_COMPANIES_LIST_SEARCH = "SET_COMPANIES_LIST_SEARCH";
export const SET_COMPANIES_LIST_FILTERS = "SET_COMPANIES_LIST_FILTERS";
export const SET_COMPANIES_LIST_PAGE = "SET_COMPANIES_LIST_PAGE";
export const SET_COMPANIES_LIST_PAGE_SIZE = "SET_COMPANIES_LIST_PAGE_SIZE";
export const RESET_COMPANIES_LIST_FILTERS = "RESET_COMPANIES_LIST_FILTERS";

export const OPEN_EDIT_COMPANY_DRAWER = "OPEN_EDIT_COMPANY_DRAWER";
export const CLOSE_EDIT_COMPANY_DRAWER = "CLOSE_EDIT_COMPANY_DRAWER";

export const UPDATE_COMPANY_REQUEST = "UPDATE_COMPANY_REQUEST";
export const UPDATE_COMPANY_SUCCESS = "UPDATE_COMPANY_SUCCESS";
export const UPDATE_COMPANY_FAILURE = "UPDATE_COMPANY_FAILURE";

export const DEACTIVATE_COMPANY_REQUEST = "DEACTIVATE_COMPANY_REQUEST";
export const DEACTIVATE_COMPANY_SUCCESS = "DEACTIVATE_COMPANY_SUCCESS";
export const DEACTIVATE_COMPANY_FAILURE = "DEACTIVATE_COMPANY_FAILURE";

export const ACTIVATE_COMPANY_REQUEST = "ACTIVATE_COMPANY_REQUEST";
export const ACTIVATE_COMPANY_SUCCESS = "ACTIVATE_COMPANY_SUCCESS";
export const ACTIVATE_COMPANY_FAILURE = "ACTIVATE_COMPANY_FAILURE";

export const GET_COMPANY_EDIT_REQUEST_SHOW_REQUEST =
  "GET_COMPANY_EDIT_REQUEST_SHOW_REQUEST";
export const GET_COMPANY_EDIT_REQUEST_SHOW_SUCCESS =
  "GET_COMPANY_EDIT_REQUEST_SHOW_SUCCESS";
export const GET_COMPANY_EDIT_REQUEST_SHOW_FAILURE =
  "GET_COMPANY_EDIT_REQUEST_SHOW_FAILURE";
export const CLEAR_COMPANY_EDIT_REQUEST_DETAIL =
  "CLEAR_COMPANY_EDIT_REQUEST_DETAIL";

export const PATCH_COMPANY_EDIT_REQUEST_REQUEST =
  "PATCH_COMPANY_EDIT_REQUEST_REQUEST";
export const PATCH_COMPANY_EDIT_REQUEST_SUCCESS =
  "PATCH_COMPANY_EDIT_REQUEST_SUCCESS";
export const PATCH_COMPANY_EDIT_REQUEST_FAILURE =
  "PATCH_COMPANY_EDIT_REQUEST_FAILURE";

/** Same strings as RegistrationReq: reducer cases live on `companiesRegistration`. */
export {
  GET_COMPANY_DETAILS_REQUEST,
  GET_COMPANY_DETAILS_SUCCESS,
  GET_COMPANY_DETAILS_FAILURE,
} from "../RegistrationReq/types";
